<script setup lang="ts">
import { useRouter } from 'vue-router'

import ThemeToggle from '@/components/ThemeToggle.vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()

async function logout(): Promise<void> {
  await auth.logout()
  await router.replace({ name: 'studio-login' })
}
</script>

<template>
  <div class="studio-layout">
    <aside class="studio-sidebar">
      <RouterLink class="studio-brand" to="/studio">安静编辑部</RouterLink>
      <nav aria-label="后台导航">
        <RouterLink to="/studio">仪表盘</RouterLink>
        <RouterLink to="/studio/articles">文章</RouterLink>
        <RouterLink to="/studio/taxonomy">分类与标签</RouterLink>
        <RouterLink to="/studio/account">账户</RouterLink>
      </nav>
      <div class="studio-sidebar-bottom">
        <RouterLink to="/">查看网站</RouterLink>
        <button class="text-button" type="button" @click="logout">退出</button>
      </div>
    </aside>
    <section class="studio-workspace">
      <header class="studio-topbar">
        <span>{{ auth.admin?.username }}</span>
        <ThemeToggle />
      </header>
      <main class="studio-main"><slot /></main>
    </section>
  </div>
</template>
